import Create from "Components/GMS/Pdw/upload/Create";
import React from "react";
import Dialog from "Components/DesignSystem/Dialog/Dialog";

/**
 * "Upload XLS - Create" — the Products-list entry point to the PDW create flow
 * (`ProductDeltaHeader.tsx`). On DS `Dialog` since § 126.
 *
 * `closeOnOutsideClick` preserves `ModalContainer`'s default `clickOutSideClose`,
 * which every caller of this wrapper already relies on.
 */
const CreatePDW = (props) => {
  return (
    <Dialog
      isOpen={!!props?.showCreatePopup}
      onClose={props?.modalCreateClose}
      closeOnOutsideClick
      title="Upload XLS - Create"
      data-testid="pdw-products-create-dialog"
    >
      <Create
        modalCreateClose={props?.modalCreateClose}
        load_Products_By_Category={props.fetchData}
        fromProduct={true}
      />
    </Dialog>
  );
};

export default CreatePDW;
